import { ClientTypes } from '../../utilities/constants'
import PlacesLogo from '../../assets/vectors/Remmi-Places-Logo-White.svg'
import StreetLogo from '../../assets/vectors/Remmi-Logo-White.svg'
import styles from './BrandLogo.module.scss'

interface Props {
    client: ClientTypes
}

const BrandLogoComponent = ({ client }:Props ) => {
    return (
        <>
            {client === 'street' ? (
                <img src={StreetLogo} alt="Brand Remmi Street Logo" className={styles.logo} />
            ) : (
                <img src={PlacesLogo} alt="Brand Remmi Places Logo" className={styles.logo} />
            )}
        </>
    )
}

export default BrandLogoComponent
